export default {
	"8a550bb53d155480f8155c5dc2fbf0c5": "您当前有在学的课程，无法享受推荐礼品哦",
	"cbda7bea79ea94fb9c26283a04a2a29b": "继续购买"
}
